import { render, staticRenderFns } from "./AccountTransactions.vue?vue&type=template&id=34a4bb7c"
import script from "./AccountTransactions.vue?vue&type=script&lang=js"
export * from "./AccountTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports